<template>
    <v-card class="rounded-4"> 
        <v-toolbar flat height="60">  
            <div :class="isMobile?'mb-10 wp-70':'mb-10 wp-50'">
                <v-text-field v-model="search" append-icon="search" label="Search employee, team" single-line hide-details clearable></v-text-field> 
            </div>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>                      
        </v-toolbar>
        <v-data-table
            :headers="isMobile?headers_mobile:headers"
            :items="all_employees_filtered"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
        >
            <template v-slot:items="props">
                <tr @click="viewUser(props.item.userId)" title="Click to view details" class="clickable">
                    <td>
                        <v-chip class="user-chip-container">
                            <v-avatar>
                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                            </v-avatar>
                            {{props.item.firstName}} {{props.item.lastName}}
                        </v-chip>
                    </td>
                    <td v-if="!isMobile">
                        <team-chips :teams="props.item.teams"></team-chips>
                    </td>
                    <td>
                        <b :class="commonfn.getStatusColor(props.item.employmentStatus)">{{commonfn.getStatusDescription(props.item.employmentStatus)}}</b>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>

import allocationApi from '@/api/allocation'
import commonfn from '@/common/functions'       //for refactor
import { getSort, getSearchKeyword, getRowsPerPage, getSelectedCompensationYear, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    components: {
        'team-chips': () => import("@/components/Common/TeamsChip"),
    },
    data () {
        const routeName = `${this.$route.name}-AllCompensationEmployees`
        const savedSort = getSort(routeName)
        
        return {
            awsS3Helper,
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: getSearchKeyword(routeName),
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'40%', sortable:true},
                {text: 'Teams',align: 'left',value: 'teams',width: '45%', sortable:true},          
                {text: 'Employment Status',align: 'left',value: 'employmentStatus',width: '10%', sortable:true},
            ],
            headers_mobile: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'50%', sortable:true},
                {text: 'Employment Status',align: 'left',value: 'employmentStatus',width: '40%', sortable:true},
            ],
            all_employees: []
        }   
    },
    methods: {
        viewUser(userId) {
            this.$emit('send', userId)
            this.closeDialog()
        },
        async getEmployees() {
            try {
                this.loading = true
                const selectedYear = getSelectedCompensationYear()
                const currentFiscalPeriodId = this.$store.state.fiscalPeriods.find(x => x.fiscalYear == selectedYear).fiscalPeriodId
                const response = await allocationApi.getSummary(currentFiscalPeriodId)        
                if (response && response.status == 200) {
                    this.all_employees = response.data.items
                }
                 this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAllEmployees', false)
        },
    },
    created() {},
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-AllCompensationEmployees`, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(`${this.$route.name}-AllCompensationEmployees`, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(`${this.$route.name}-AllCompensationEmployees`, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        all_employees_filtered() {
            var temp = this.all_employees

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    const searchTerm = this.search.toLowerCase()
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchTerm)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchTerm)
                    const teamsMatch = item.teams.join(', ').toLowerCase().includes(searchTerm)

                    return firstNameMatch || lastNameMatch || teamsMatch
                })
            }
            return temp
        },
    }
}
</script>